
export const getKColorValue = (output, responses) => {
  const inputId = JSON.parse(output.calculation[0])?.kcolor_question;
  return responses[inputId]?.value;
};

export const getSurfaceValue = (output, responses) => {
  const inputId = JSON.parse(output.calculation[0])?.surface_question;
  return responses[inputId]?.value;
};


export const splitCode = (code: string) => {
  return code.replace(/^([A-Za-z]+)(\d+)$/, '$1 $2');
}

